import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { extender } from "../../backend/class-extender";
import { NotificationBase } from "../notification-base";
import { OrganizationManager } from "../organization-manager/entity";
import { OrganizationManagerNotificationEntityConfig } from "./config";
import { OrganizationManagerNotificationFilters } from "./filters";
import { OrganizationManagerNotificationMethods } from "./methods";

@HyperEntity(
  "organization-manager-notification",
  OrganizationManagerNotificationEntityConfig,
)
export class OrganizationManagerNotification extends extender(
  NotificationBase,
  OrganizationManagerNotificationFilters,
  OrganizationManagerNotificationMethods,
) {
  @Fields.string({
    dbName: "to_id",
  })
  toId = "";

  @Relations.toOne<OrganizationManagerNotification, OrganizationManager>(
    () => OrganizationManager,
    "toId",
  )
  to?: OrganizationManager;
}
